export enum ResourceAccessRule {
  Shared = 'Shared',
  Private = 'Private',
}
